import { render, staticRenderFns } from "./IssuesTypesFormValidation.vue?vue&type=template&id=22aa64ec"
import script from "./IssuesTypesFormValidation.vue?vue&type=script&lang=js"
export * from "./IssuesTypesFormValidation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports